import React, { FunctionComponent } from 'react'
import { ReactComponent as TaskEmptyIcon } from '../../../../assets/images/tasks/tasks.svg'
import { ReactComponent as TaskVectorArrowIcon } from '../../../../assets/images/tasks/rollingArrow.svg'
import { RoundedButton } from '../../../shared'
import { TaskEmptyStateProps } from './TaskEmptyState.model'
import styles from './TaskEmptyState.module.scss'

export const TaskEmptyState: FunctionComponent<TaskEmptyStateProps> = ({ newTask }) => {
  return (
    <div className={styles.taskEmptyStateContainer}>
      <div className={styles.taskEmptyStateContent}>
        <div className={styles.taskEmptyStateInfos}>
          <div className={styles.taskEmptyStateImage}>
            <TaskEmptyIcon />
          </div>
          <h2 className={styles.taskEmptyStateNoTaskText}>Aucune tâche</h2>
          <div className={styles.taskEmptyStateNoTaskTextDetails}>
            <p>Vous n’avez actuellement aucune tâche à réaliser.</p>
            <p>Commencez par ajouter une nouvelle tâche sur Follow.</p>
          </div>
          <div className={styles.taskEmptyStateCreateTaskButton}>
            <RoundedButton
              label="Nouvelle tâche"
              icon="add"
              size="normal"
              theme="primary"
              onClick={newTask}
              disabled={!newTask}
              testId="button-task-create"
            />
          </div>
          <div className={styles.taskEmptyStateIcon}>
            <TaskVectorArrowIcon />
          </div>
        </div>
      </div>
    </div>
  )
}
